export const SET_TICKET = 'SET_TICKET';
export const RESET_TICKET = 'RESET_TICKET';
